import React from 'react';
import './categories.css'
import {data, Link} from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import {useData} from "../../../context/DataContext";
import useHandleRequest from "../../../custom_hooks/useHandleRequest";



function Categories({categories=[] ,bgColor,directory}) {
    const {handleRequestAndNavigate} = useHandleRequest();
    return (
        <div className={'category'}>
            <div className={'p-4'} style={{backgroundColor: bgColor}}>
                <p>دسته‌بندی‌ها</p>
                <hr/>
                <ul>
                    {categories.map(category=> (
                        <li key={category.id}>
                            <Link to={`/${directory}/category/${category.id}/posts/`}
                                  onClick={(e) => handleRequestAndNavigate(e, `/${directory}/category/${category.id}/posts/`, `/${directory}/category/${category.id}/posts/`, `${directory}`)}
                            ><FaChevronLeft />{category.title}</Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Categories;